import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import {LANGUAGE} from "./Language";
import useSiteState from "@app/state/SiteState";
import {messagesEn} from "@app/component/translation/i8n/messages-en";
import {messagesEl} from "@app/component/translation/i8n/messages-el";

export const useTranslation = (prefix?: string) => {

    const [language, setLanguage] = useSiteState(state => [state.language, state.setLanguage]);

    const findMessages = (language: LANGUAGE) => {
        switch (language) {
            case "el" :
                return messagesEl
            case "en" :
                return messagesEn
            default:
                return messagesEn
        }
    }

    const doTranslate = (key: string, ...params: string[]) => {
        const prx = prefix ? (prefix + '.') : '';
        try {
            const text = get(findMessages(language), prx + key, prx + key);

            return !isEmpty(params) ? text.replace(/{(\d+)}/g, (...args) => {
                return params[args[1]];
            }) : text;
        } catch (e) {
            return key;
        }
    }

    const set = (language: LANGUAGE) => {
        setLanguage(language)
    }

    return {
        t: (key: string, ...params: string[]) => doTranslate(key, ...params),
        is: (lang: LANGUAGE) => language == lang,
        set: (language: LANGUAGE) => set(language)
    }
}
